<div class="container-fluid">
    <div class="row justify-content-center mt-5">
      <header class="header">
        <h3 class="text-center">Glueing</h3>
      </header>
      <div class="col-lg-12">
        <div class="card">

          <div class="row mb-2 mt-2">
            <div class="col-md-2 mt-3 offset-md-10">
            <button class="btn btn-outline-primary btn-sm"><a routerLinkActive="router-link-active" routerLink="/glueingProdTable">
              <span class="nav-menu-item-title"> 
                  <i class="feather icon-tag ng-star-inserted"></i>Glueing Records</span>
          </a></button>
          </div>
          </div>
          <div class="card-body">
            <form [formGroup]="tempGlueingForm" (ngSubmit)="tempGlueing()" (keydown.enter)="$event.preventDefault()">
              <div class="row mb-3">
  
                <!-- Ticket Number Selector -->
                <div class="col-md-2 mb-3">
                  <label for="ticketNo" class="form-label">Ticket Number</label>
                  <select formControlName="ticketNo" id="ticketNo" class="form-control" (change)="onTicketSelect($event)" *ngIf="tickets.length > 0">
                    <option value="">Select Ticket</option>
                    <option *ngFor="let ticket of tickets" [value]="ticket.ticketno">{{ ticket.ticketno }}</option>
                  </select>
                  <!-- <div *ngIf="tickets.length === 0">Loading tickets...</div> -->
                </div>
  
             
  
                <!-- Date Input -->
                <div class="col-md-2 mb-3">
                  <label for="date" class="form-label">Date</label>
                  <input type="date" id="date" class="form-control" placeholder="Enter Date" formControlName="date" />
                </div>


                <div class="col-md-2 mb-3">
                  <label class="form-label">Shift</label>
          <select class="form-select" formControlName="shift" required>
              <option value="" disabled selected>Select Shift</option>
              <option value="A">A</option>
              <option value="B">B</option>
              <option value="C">C</option>
              <option value="A 12">A 12</option>
              <option value="B 12">B 12</option>
          </select>
              </div>

              <div class="col-md-2 mb-3">
                <label for="machine" class="form-label">Machine</label>
                <select class="form-select" formControlName="machine" required>
                    <option value="" disabled selected>Select Machine</option>
                    <option value="GLUING-01(IND)">GLUING-01(IND)</option>
                    <option value="GLUING-02(GECL)">GLUING-02(GECL)</option>
                    <option value="GLUING-03(GECL)">GLUING-03(GECL)</option>
                    <option value="GLUING-03(---)">GLUING-03(---)</option>
                   
                </select>
              </div>
              

              <div class="col-md-2 mb-3">
                <label for="operator" class="form-label">Operator</label>
                <select class="form-select" formControlName="operator" id="operator" >
                    <option value="" disabled selected>Select Operator</option>
                    <option value="SURESH BHOJANAE" selected="">SURESH BHOJANAE</option>
                    <option value="MANGESH SHELAR">MANGESH SHELAR</option>
                    <option value="VAHID KHOT">VAHID KHOT</option>
                    <option value="VIGNESH DESAI">VIGNESH DESAI</option>
                    <option value="RAGHAVENDRA SAFI">RAGHAVENDRA SAFI</option>
                    <option value="GAJENDRA PRATAP SINGH">GAJENDRA PRATAP SINGH</option>
                    <option value="PRASHANT DAS">PRASHANT DAS</option>
                    <option value="AJAY KUMAR">AJAY KUMAR</option>

                    <option value="NIRANJAN YADAV">NIRANJAN YADAV</option>
                    <option value="MAYUR CHAVAN">MAYUR CHAVAN</option>
                    <option value="SURAJ SINGH CHAUHAN">SURAJ SINGH CHAUHAN</option>
                    <option value="VIKRAM SINGH">VIKRAM SINGH</option>
                    <option value="SHIVAM BHARDWAJ">SHIVAM BHARDWAJ</option>
                    <option value="SHIVAM KUMAR">SHIVAM KUMAR</option>
                    <option value="SACHIN KOLHE">SACHIN KOLHE</option>
                    <option value="PRIYANSHU VERMA">PRIYANSHU VERMA</option>
                    <option value="RANJAN SETHI">RANJAN SETHI</option>
                    <option value="SURENDRA PAL">SURENDRA PAL</option>
                    <option value="DHEERAJ">DHEERAJ</option>
                    <option value="DELE- OLANREWAJU SAHEED">DELE- OLANREWAJU SAHEED</option>
                    <option value="WASIU KAYODE BUSARI">WASIU KAYODE BUSARI</option>
                    <option value="IBRAHIM OLADIMEJI">IBRAHIM OLADIMEJI</option>
                    <option value="FOLAYINKA KILANI">FOLAYINKA KILANI</option>

                     <option value="ABIODUN OLALEKAN ADEBIJI">ABIODUN OLALEKAN ADEBIJI</option>
                      <option value="DANIEL OLUWADAMILARE">DANIEL OLUWADAMILARE</option>
                    <option value="DEEPAK SHARMA">DEEPAK SHARMA</option>
                    <option value="SANJAY CHAURASIYA">SANJAY CHAURASIYA</option>
                    <option value="VIVEK KUMAR">VIVEK KUMAR</option>
                    <option value="ARUN">ARUN</option>
                    <option value="SOLOMAN">SOLOMAN</option>
                    <option value="ENOCH">ENOCH</option>
                    <option value="FRANCISCA">FRANCISCA</option>
                    <option value="PATIENCE">PATIENCE</option>
                    <option value="SAMUEL">SAMUEL</option>
                    <option value="BRUCE">BRUCE</option>
                    <option value="MARY">MARY</option>
                    <option value="ROMEO">ROMEO</option>
                    <option value="REUBEN">REUBEN</option>
                    <option value="MAWUENA">MAWUENA</option>

                    <!-- Newly added names -->
    <option value="JOEL">JOEL</option>
    <option value="MARK">MARK</option>
    <option value="DANIEL">DANIEL</option>
    <option value="ABBEY">ABBEY</option>
    <option value="KING">KING</option>
    <option value="FOSTER">FOSTER</option>
    <option value="JUDITH">JUDITH</option>
    <option value="OLIVIA">OLIVIA</option>
    <option value="BEATRICE">BEATRICE</option>
    <option value="VERA">VERA</option>
    <option value="VIKAS">VIKAS</option>
    <option value="ARUN">ARUN</option>
    <option value="AKIN">AKIN</option>
    <option value="SAFIATU">SAFIATU</option>
    <option value="PATRICIA">PATRICIA</option>
    <option value="BERNICE">BERNICE</option>

        <option value="STEVEN">STEVEN</option>
    <option value="OSMAN">OSMAN</option>
    <option value="EMMANUEL">EMMANUEL</option>
    <option value="MAJEED">MAJEED</option>
    <option value="RAM KISHAN">RAM KISHAN</option>
    <option value="BASIT">BASIT</option>
    <option value="SAMAD">SAMAD</option>
    <option value="HARSHA">HARSHA</option>

   <option value="VISHAL">VISHAL</option>
   <option value="ADEMOLA">ADEMOLA</option>
   <option value="ASHISH">ASHISH</option>
   <option value="DAVID AWONARO">DAVID AWONARO</option>

   
     <option value="DHANJAY">DHANJAY</option>
      <option value="VINAY">VINAY</option>
       <option value="VINAY KUMAR SINGH">VINAY KUMAR SINGH</option>
    <option value="KOLA">KOLA</option>
                </select>
              </div>

  
  
                <!-- Width Input -->
                <!-- <div class="col-md-4 mb-3">
                  <label for="width" class="form-label">Enter Width</label>
                  <input type="text" id="width" class="form-control" placeholder="Enter Width" formControlName="width" />
                </div> -->
                <!-- <div class="col-md-4 mb-3">
                    <label for="std" class="form-label">Enter Std</label>
                    <input type="text" id="std" class="form-control" placeholder="Enter Std" formControlName="std" />
                  </div> -->
  
                <!-- Reference Number Input -->
                <div class="col-md-2 mb-3">
                  <label for="refNo" class="form-label">Reference Number</label>
                  <input type="text" id="refNo" class="form-control" placeholder="Enter Reference Number" formControlName="refNo" />
                </div>
  
                <!-- PO Number Input -->
                <!-- <div class="col-md-4 mb-3">
                  <label for="poNumber" class="form-label">PO Number</label>
                  <input type="text" id="poNumber" class="form-control" placeholder="Enter PO Number" formControlName="poNumber" />
                </div> -->
  

                <div class="col-md-12 mb-1 mt-2">
                  <label for="combinedMaterials" class="form-label">Production</label></div>

                   <!-- Job Name Input -->
                   <div class="col-md-4 mb-3">
                    <label for="jobName" class="form-label">Job Name</label>
                    <input type="text" id="jobName" class="form-control" placeholder="Enter Job Name" formControlName="jobName" />
                  </div>
                
                <!-- Client Name Input -->
                <div class="col-md-4 mb-3">
                  <label for="clientName" class="form-label">Client Name</label>
                  <input type="text" id="clientName" class="form-control" placeholder="Enter Client Name" formControlName="clientName" />
                </div>

                <div class="col-md-4 mb-3">
                  <label for="material" class="form-label">Material</label>
                  <input type="text" formControlName="mat" class="form-control" placeholder="Material" />
                </div>





                <!-- <div class="col-md-12 mb-1 mt-2">
                  <label for="combinedMaterials" class="form-label">Materials</label></div> -->


                

                

                <!-- <div class="col-md-6 mb-3">
                  <label for="material" class="form-label">Material 2</label>
                  <input type="text" formControlName="materialLam" class="form-control" placeholder="Material" />
                </div> -->
                 





                <div class="col-md-12 mb-1 mt-2">
                  <label for="combinedMaterials" class="form-label">I/O</label></div>

                <div class="col-md-2 mb-3">
                  <label for="Input" class="form-label">Input</label>
                        <input type="text" formControlName="input" class="form-control" placeholder="Input" />
                </div>

                <div class="col-md-2 mb-3">
                  <label for="Output" class="form-label">Output</label>
                        <input type="text" formControlName="output" class="form-control" placeholder="Output" />
                </div>

                 <div class="col-md-2 mb-3">
                  <label for="JCO" class="form-label">JCO</label>
                        <input type="text" formControlName="jco" class="form-control" placeholder="JCO" />
                </div>

                 <div class="col-md-2 mb-3">
                  <label for="No.of rolls" class="form-label">No.of rolls</label>
                        <input type="text" formControlName="rollcount" class="form-control" placeholder="No.of rolls" />
                </div>

                 <div class="col-md-2 mb-3">
                    <label for=" Plain Wastage" class="form-label"> Pic/Kg</label>
                          <input type="text" formControlName="pckg" class="form-control" placeholder=" Pic/Kg" />
                  </div>

                   <div class="col-md-2 mb-3">
                    <label for=" Plain Wastage" class="form-label"> Total Pieces</label>
                          <input type="text" formControlName="tpcs" class="form-control" placeholder=" Total Pieces" />
                  </div>

                
              




                <div class="col-md-12 mb-1 mt-2">
                  <label for="combinedMaterials" class="form-label">Wastage</label></div>

                 
  
                  <div class="col-md-2 mb-3">
                    <label for=" Plain Wastage" class="form-label"> Plain Wastage</label>
                          <input type="text" formControlName="ip" class="form-control" placeholder=" Plain Wastage" />
                  </div>
  
                  <div class="col-md-2 mb-3">
                    <label for="Print Wastage" class="form-label">Print Wastage</label>
                          <input type="text" formControlName="job" class="form-control" placeholder="Print Wastage" />
                  </div>
  
               
                


              
                    <div class="col-md-2 mb-3">
                      <label for="Shade Matching" class="form-label">Output Wastage</label>
                            <input type="text" formControlName="shade" class="form-control" placeholder="Wastage" />
                    </div>
  
                  <div class="col-md-2 mb-3">
                    <label for="Others" class="form-label">Other Wastage</label>
                          <input type="text" formControlName="others" class="form-control" placeholder="Wastage" />
                  </div>

                  <div class="col-md-2 mb-3">
                    <label for="Wastage" class="form-label">Total Wastage</label>
                          <input type="text" formControlName="wastage" class="form-control" placeholder="Wastage" />
                  </div>


                  




                  <div class="col-md-12 mb-1 mt-2">
                    <label for="combinedMaterials" class="form-label">Additional Info</label></div>

                     <div class="col-md-4 mb-3">
                    <label for="Rolls" class="form-label">Tube Size</label>
                          <input type="text" formControlName="rolls" class="form-control" placeholder="Rolls" />
                  </div>
  
  
                  <div class="col-md-4 mb-3">
                    <label for="glueSupplier" class="form-label">Glue Supplier</label>
                             <select formControlName="glueSupplier" class="form-control" id="glueSupplier">
        <option value="" disabled >Select Supplier</option>
        <option value="China">China</option>
        <option value="Local">Local</option>
    </select>
                  </div>


                  <div class="col-md-4 mb-3">
                    <label for="Remarks" class="form-label">Remarks</label>
                          <input type="text" formControlName="remarks" class="form-control" placeholder="Remarks" />
                  </div>
  
  

                





  
                <!-- Dynamic Combined Materials Section -->
                <!-- <div class="col-md-12 mb-3">
                  <label for="combinedMaterials" class="form-label">Combined Materials</label>
                  <div formArrayName="combinedMaterials">
                    <div *ngFor="let material of getCombinedMaterialsControls(); let i = index" [formGroupName]="i" class="row">
                      <div class="col-md-2">
                        <label for="material" class="form-label">Material</label>
                        <input type="text" formControlName="material" class="form-control" placeholder="Material" />
                      </div>
                      <div class="col-md-2">
                        <input type="text" formControlName="density" class="form-control" placeholder="Density" />
                      </div>
                      <div class="col-md-2">
                        <input type="text" formControlName="gsm" class="form-control" placeholder="GSM" />
                      </div>
                      <div class="col-md-2">
                        <input type="text" formControlName="matRequired" class="form-control" placeholder="Mat Required" />
                      </div>
                      <div class="col-md-2">
                        <input type="text" formControlName="netRm" class="form-control" placeholder="Net RM" />
                      </div>
                      <div class="col-md-2">
                        <label for="Process" class="form-label">Process</label>
                        <input type="text" formControlName="process" class="form-control" placeholder="Process" />
                      </div>
                      <div class="col-md-2">
                        <label for="Thickness" class="form-label">Thickness</label>
                        <input type="text" formControlName="thickness" class="form-control" placeholder="Thickness" />
                      </div>
                      <div class="col-md-2">
                        <input type="text" formControlName="waste" class="form-control" placeholder="Waste" />
                      </div>
                      <div class="col-md-2">
                        <label for="Width" class="form-label">Width/Size</label>
                        <input type="text" formControlName="width" class="form-control" placeholder="Width" />
                      </div>
                      <div class="col-md-2">
                        <button type="button" class="btn btn-danger" (click)="removeMaterial(i)">Remove</button>
                      </div>
                    </div>
                  </div>
  
                 
                  <button type="button" class="btn btn-outline-primary" (click)="addMaterial()">Add Material</button>
                </div> -->
  
              </div>
  
              <!-- Submit Button -->
              <div class="text-end">
                <button type="submit" class="btn btn-outline-dark">Submit</button>
              </div>
            </form>
          </div><!-- end card-body -->
        </div><!-- end card -->
      </div><!-- end col -->
    </div><!-- end row -->
  </div><!-- end container -->
  